import React, { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { getField } from 'components/form-multi/utils';
import ModalNew from 'components/utils/ModalNew';

import { changeFormFieldValue, setNewForm } from 'actions/formAction';

import { PHONE_COUNTRY, PHONE_NUMBER, PHONE_PREFIX } from 'constants/fieldsName';
import { NO_AUTH_LOGIN_REGISTRATION_FORM_NAME } from 'constants/formName';
import { PHONE_CUSTOM_MASK, EXCLUDE_COUNTRIES } from 'constants/utilsMasks';

import colors from 'theme/colors';

import PromoSelectCountryWithCode from './PromoSelectCountryWithCode';
import { LightFlagIcon } from '../../common/fromAuth/LightFlagIcon/LightFlagIcon';
import { LightIcon } from '../../common/fromAuth/LightIcon/LightIcon';
import PromoInputWrapper from '../PromoInputWrapper';

const FlagIconDropdown = styled.div`
    display: flex;
    padding-right: 8px;
    margin-right: 16px;
    border-right: 1px solid ${colors.superLightGray};
    cursor: pointer;
`;

const PromoInputPhoneWithDropdown = (props) => {
    const ref = useRef(null);
    const modalRef = useRef(false);
    const [iso2, updateIso2] = useState('');
    const [prefix, setPrefix] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const getDefaultCountry = () => {
        return props.countries.find(({ code_a2 }) => code_a2.toLowerCase() === 'gb');
    };

    const getPureValue = (prefix) => {
        return prefix.replace(/\D+/g, '');
    };

    useEffect(() => {
        const currentCountry = props.countries?.find(({ code_a2 }) => code_a2.toLowerCase() === props.currentCountry) || getDefaultCountry();
        const currentCountryCode = currentCountry.code_a2.toLowerCase();
        updateIso2(currentCountryCode);
        setPrefix(currentCountry.phone_prefix);

        let fields = {};
        fields[PHONE_NUMBER] = getField(PHONE_NUMBER, '', undefined, true, false, undefined, 'tel');
        fields[PHONE_PREFIX] = getField(PHONE_PREFIX, '', undefined, true, false, undefined, 'tel');
        fields[PHONE_COUNTRY] = getField(PHONE_COUNTRY, '', undefined, true, false, undefined, 'tel');
        props.setNewForm(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, fields);
        props.changeFormFieldValue(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, currentCountry.phone_prefix, PHONE_PREFIX);
        props.changeFormFieldValue(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, currentCountryCode, PHONE_COUNTRY);
    }, []);

    const handlerFocus = () => {
        setIsFocused(true);
    };

    const handlerBlur = () => {
        setIsFocused(false);
    };

    const focus = (e) => {
        if (e.currentTarget) {
            const input = e.currentTarget.firstElementChild;
            input.focus();
        } else {
            if (__isDev__) {
                console.log('Focus method not support');
            }
        }
    };

    const showCountryModal = () => {
        modalRef?.current?.open(
            <PromoSelectCountryWithCode
                countries={props.countries}
                modalRef={modalRef}
                onCountryItemClick={onCountryItemClick}
                searchPlaceholder={props.searchPlaceholder}
                searchFullPlaceholder={props.searchFullPlaceholder}
                searchModalTitle={props.searchModalTitle}
                searchNoResult={props.searchNoResult}
                iso2={iso2}
            />,
        );
    };

    const onCountryItemClick = (code, prefix) => {
        updateIso2(code);
        setPrefix(prefix);
        props.changeFormFieldValue(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, prefix, PHONE_PREFIX);
        props.changeFormFieldValue(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, code, PHONE_COUNTRY);
        modalRef?.current?.close();
    };

    const handlerChange = (value) => {
        const purePhoneNumber = value.replace(getPureValue(prefix), '');
        props.changeFormFieldValue(NO_AUTH_LOGIN_REGISTRATION_FORM_NAME, purePhoneNumber, PHONE_NUMBER);
    };

    return (
        <>
            <PromoInputWrapper
                labelText={props.labelText}
                isFilled={true}
                isFocused={isFocused}
                setIsFocused={setIsFocused}
                name="search"
                setFocus={focus}
                leftInputComponent={
                    <FlagIconDropdown onClick={showCountryModal}>
                        <LightFlagIcon name={iso2} />
                        <LightIcon name="chevron-down" leftIndent="4px" />
                    </FlagIconDropdown>
                }
            >
                <PhoneInput
                    ref={ref}
                    inputProps={{
                        autoComplete: 'tel',
                    }}
                    specialLabel={''}
                    value={prefix}
                    disableDropdown={true}
                    countryCodeEditable={false}
                    placeholder={''}
                    isFocused={isFocused}
                    defaultCountry={iso2}
                    defaultMask={'... ... ... ... ..'}
                    masks={PHONE_CUSTOM_MASK}
                    excludeCountries={EXCLUDE_COUNTRIES}
                    isFilled={true}
                    onChange={handlerChange}
                    onFocus={handlerFocus}
                    onBlur={handlerBlur}
                    enableLongNumbers={16}
                    enableTerritories={true}
                />
            </PromoInputWrapper>
            <ModalNew ref={modalRef} />
        </>
    );
};
export default connect(null, { changeFormFieldValue, setNewForm })(PromoInputPhoneWithDropdown);
